import './Footer.scss';

const Footer = () => {
  return (
    <footer className='footer'>
      <p className="copy">&copy; Developer-Talks.</p>
    </footer>
  );
};

export default Footer;